import XHR from '../utils/xhr';
import ConfigStore from '../stores/Config';

export function fetchServiceById(id) {
  if (!id) return null;
  return XHR.getRequest(`${ConfigStore.getApiBaseUrl({ version: 2 })}/auth/services/${id}`, {
    params: {
      with_category_ids: true
    }
  })
    .then(res => {
      return res;
    })
    .catch(() => {
      return null;
    });
}

export function updateServiceById(id, service) {
  if (!id || !service) return;
  const olaBaseApiUrlV1 = ConfigStore.getApiBaseUrl();

  return XHR.patchRequest(`${olaBaseApiUrlV1}/services/${id}`, {
    data: { service }
  });
}

export function deleteServiceById(id) {
  if (!id) return;
  const olaBaseApiUrlV1 = ConfigStore.getApiBaseUrl();

  return XHR.deleteRequest(`${olaBaseApiUrlV1}/services/${id}`);
}

export function createService(service) {
  const olaBaseApiUrlV1 = ConfigStore.getApiBaseUrl();

  return XHR.postRequest(`${olaBaseApiUrlV1}/services`, {
    data: { service }
  });
}

// Creates the starter set of services (idempotent backend, no-op if services already exist).
export function autoCreateStarterServices() {
  const olaBaseApiUrlV1 = ConfigStore.getApiBaseUrl();

  return XHR.postRequest(`${olaBaseApiUrlV1}/services/auto_create_starter`);
}
